import { useEffect, useState } from 'react';
import { observeSecureCardNumberFilled } from '../utils/observeSecureCardNumberFilled';
export function useSecureCardNumberFilled(cardNumberId) {
    const [isFilled, setIsFilled] = useState(false);
    useEffect(() => observeSecureCardNumberFilled(cardNumberId, setIsFilled), [cardNumberId]);
    return isFilled;
}
